import { useContext } from 'react';
import {
  SessionsContext,
  type SessionsContextValue,
} from '../contexts/SessionsContext';

export const useSessions = (): SessionsContextValue => {
  const context = useContext(SessionsContext);
  if (!context) {
    throw new Error('useSessions must be used within SessionsProvider');
  }
  return context;
};
